import React from 'react';

const LOGO_URL = '/brand/tap-in-app-icon.png';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
    this.setState({ error, errorInfo });
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null, errorInfo: null });
    window.location.href = '/app';
  };

  render() {
    if (this.state.hasError) {
      const errorMsg = this.state.error?.message || 'Unknown error';
      const errorStack = this.state.error?.stack || '';
      // Extract the first meaningful line from stack
      const firstLine = errorStack.split('\n').slice(0, 3).join('\n');
      
      return (
        <div className="min-h-screen bg-white flex flex-col items-center justify-center px-6">
          <div className="relative mb-6">
            <img 
              src={LOGO_URL}
              alt="Tap In"
              className="w-20 h-20 relative z-10 object-contain"
            />
          </div>
          
          <p className="text-gray-800 text-base font-semibold mb-1">Something went wrong</p>
          <p className="text-gray-400 text-sm mb-4 text-center max-w-xs">
            An unexpected error occurred. Tap below to go back.
          </p>

          {/* Show error details for debugging */}
          <div className="bg-gray-50 rounded-lg p-3 mb-6 max-w-sm w-full">
            <p className="text-red-500 text-xs font-mono break-all">{errorMsg}</p>
            <p className="text-gray-400 text-[10px] font-mono mt-1 break-all whitespace-pre-wrap">{firstLine}</p>
          </div>

          <button
            onClick={this.handleRetry}
            className="px-8 py-3 rounded-2xl bg-gradient-to-r from-blue-500 to-blue-600 text-white font-semibold text-sm shadow-lg shadow-blue-500/25 active:scale-95 transition-transform"
            data-testid="error-boundary-retry-btn"
          >
            Back to Dashboard
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
